<template>
    <div class="order-detail-section mg20">
        <h3>学校规模</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项">
                学校规模
            </el-table-column>
            <el-table-column label="修订后内容">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容">
                <template slot-scope="scope" >
                    <span v-html=scope.row.old_content></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        name: "scale",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: { 
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    let old_class_num = 0;
                    let old_teacher_num = 0;
                    if(this.order.before_content.hasOwnProperty('class_num')){
                        old_class_num = this.order.before_content.class_num;
                    }
                    if(this.order.before_content.hasOwnProperty('teacher_num')){
                        old_teacher_num = this.order.before_content.teacher_num;
                    }

                    let new_class_num = 0;
                    let new_teacher_num = 0;
                    if(this.order.content.hasOwnProperty('class_num')){
                        new_class_num = this.order.content.class_num;
                    }
                    if(this.order.content.hasOwnProperty('teacher_num')){
                        new_teacher_num = this.order.content.teacher_num;
                    }
                    let new_content_class_str = '班级数：'+ new_class_num;
                    if(old_class_num != new_class_num){
                        new_content_class_str = '<span style="color: red">班级数：'+ new_class_num +'</span>';
                    }
                    let new_content_teacher_str = '教师数：'+ new_teacher_num;
                    if(old_teacher_num != new_teacher_num){
                        new_content_teacher_str = '<span style="color: red">教师数：'+ new_teacher_num +'</span>';
                    }
                    this.test.push({
                        new_content: new_content_class_str + '<br/>' + new_content_teacher_str,
                        old_content: '班级数：' + old_class_num + '<br/>教师数：' + old_teacher_num,
                    });
                }
            }
        },
        data() {
            return {
                test:[],
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/finance/scale.vue